/**
 * Access scope helpers for permission checks.
 * Single source of truth for scopes/roles that can invite and for primary-admin checks.
 */

/** Scopes that allow inviting users (primary-organization and organization). */
const INVITE_SCOPES = new Set([
  'primary-organization',
  'primary_admin',
  'organization',
  'organization_admin',
]);

/**
 * @param {Object|null} user - Auth user (accessScope, role)
 * @returns {boolean} true if user can invite users (primary-organization or organization scope/role)
 */
export function canInviteUsers(user) {
  if (!user || typeof user !== 'object') return false;
  const scope = user.accessScope ?? user.role;
  return INVITE_SCOPES.has(scope) || INVITE_SCOPES.has(user.role);
}

/**
 * @param {Object|null} user - Auth user (accessScope, role)
 * @returns {boolean} true if user is primary admin (can edit organization)
 */
export function isPrimaryAdminUser(user) {
  if (!user || typeof user !== 'object') return false;
  const scope = user.accessScope ?? user.role;
  return (
    scope === 'primary-organization' ||
    scope === 'primary_admin' ||
    user.role === 'primary_admin'
  );
}
